import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AccountCtlService, AccountStatementCtlService, PartnerCtlService } from '../api/services';
import { SessionService } from '../common/session.service';
import { ExcelService } from '../common/excel.service';
import { PdfService } from '../common/pdf.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { BalanceDto, PartnerDto } from '../api/models';

@Component({
  selector: 'app-account',
  imports: [
    CommonModule,
    NgxPaginationModule,
    ReactiveFormsModule
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent implements OnInit {

  pageConfig= {
    itemsPerPage: 10,
    currentPage: 0,
    totalItems: 0
   };

  stateForm: FormGroup;
  statements?:any;
  balance?:BalanceDto;
  realBalance?:any;
  availableBalance?:any;
  idPartner?:any;
  partnerType?:string;
  startDate:string='';
  endDate:string='';
  messageColor ='text-success';
  message='';
  merchants?:Array<PartnerDto>;
  partner?:PartnerDto;
  currentIdPartner?:number;



  constructor( private formBuilder:FormBuilder,
    private statementService:AccountStatementCtlService,
    private accountService:AccountCtlService,
    private session:SessionService,
    private partnerService:PartnerCtlService,
    private excelService:ExcelService,
    private pdfService:PdfService
  ){
    this.stateForm = this.formBuilder.group({
      end: ['',Validators.required],
      start: ['',Validators.required],
      idPartner:['',Validators.required]
    });
  }
  ngOnInit(): void {
    this.partner=this.session.getSessionInfo().partner;
    this.partnerType=this.partner?.type;
    console.log(this.partnerType);
    if(this.partner?.canBeParent==true){
      this.loadMerchants();
      
    }else {
       this.idPartner =this.session.getSessionInfo().partner?.id;
      console.log(this.idPartner);
      this.stateForm.controls['idPartner'].setValue(this.idPartner);
      this.onLoadStates(); 
    }
  }
  loadMerchants()
  {
    this.partnerService.getChildren1(
      this.session.getSessionInfo().partner?.id!!,
      undefined,
      1000,
      0
    ).subscribe(
      {
        next:(resp)=>{
          this.merchants = resp.content;
        }
      }
    )
  }
   onLoadStates(){
      let form = this.stateForm.value;
      
      if(form.start.length>0){
        this.startDate = form.start.substring(8,10)+'/'+form.start.substring(5,7)+'/'+form.start.substring(0,4);
       
     }
     if(form.end.length>0){
      this.endDate = form.end.substring(8,10)+'/'+form.end.substring(5,7)+'/'+form.end.substring(0,4);
       
    }
    this.currentIdPartner=form.idPartner;
    this.loadStatements(this.currentIdPartner!!,this.startDate,this.endDate,20,0);
  
      
    }
    getBalancePartner(){

      this.accountService.getBalance(
         this.idPartner,
         undefined
      ).subscribe({
        next:(resp)=>{
          this.balance = resp; 
         this.realBalance =  new Intl.NumberFormat('sn-SN', { style: 'currency', currency: 'XOF' }).format(
            this.balance.balance!!,
          );
          this.availableBalance =new Intl.NumberFormat('sn-SN', { style: 'currency', currency: 'XOF' }).format(
            this.balance.availableBalance!!,
          );
          console.log(this.realBalance);   
        },
        error:(err)=>{
         console.log(err.error);
          this.balance = {
            balance: 0,
            availableBalance: 0
          };
         
        }
      });
    }
    abs(amount:number){
      return Math.abs(amount);
    }
    exportToExcel(){
      let form = this.stateForm.value;
      this.statementService.getAccountStatement(
         form.idPartner,
         undefined,
         this.startDate,
         this.endDate,
        -1
      ).subscribe({
        next:(resp)=>{
          let content =[['DATE','MONTANT','DESCRIPTION','SENS']];
            
            resp.content?.forEach(el => {
              
              var sens = 'DEBIT';
              if(el.amount!!>0){
              sens = 'CREDIT';
            }
              var line:any[] =[el.dateWriting,this.abs(el.amount!!),el.description,sens];
              content.push(line);
            });
            this.excelService.exportAsExcelFile(content,'releve','releve');
        }
      });
    }
    exportToPdf(){
      let form = this.stateForm.value;
      this.statementService.getAccountStatement(
         form.idPartner,
         undefined,
         this.startDate,
         this.endDate,
        -1
      ).subscribe({
        next:(resp)=>{
          let headers =[['DATE','MONTANT','DESCRIPTION','SENS']];
          let content:any[]=[];
            resp.content?.forEach(el => {
              var sens = 'DEBIT';
              if(el.amount!!>0){
              sens = 'CREDIT';
            }
              var line:any[] =[el.dateWriting,this.abs(el.amount!!),el.description,sens];
              content.push(line);
            });
            this.pdfService.generateFile(headers,content,'Releve compte','releve-'+new Date().getTime());
        }
      });
    }
    onNextPage(event:number){
      console.log(event);
      this.loadStatements(this.currentIdPartner!!, this.startDate,this.endDate, this.pageConfig.itemsPerPage,event-1);
    }
    loadStatements(idPartner:number,startDate:string,endDate:string,sizeV:number=20,pageNumber:number=0){
      console.log('size ',sizeV);
      this.statementService.getAccountStatement(
         idPartner,
         undefined,
         startDate,
         endDate,
        pageNumber,
        sizeV
      ).subscribe({
        next:(resp)=>{
          this.statements = resp;
        }
      });
    }
}
